'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ProgressiveImageFACC = require('./ProgressiveImageFACC');

var _ProgressiveImageFACC2 = _interopRequireDefault(_ProgressiveImageFACC);

var _BackgroundImage = require('../BackgroundImage');

var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);

require('./ProgressiveImage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Shows an image which progressively becomes better quality by first showing a thumbnail of the image,
 * and then, once the larger version has loaded, replaces the thumbnail with the full size image.
 *
 * NOTE: The component initially shows the source file because it would otherwise cause a flash of content when dragging
 * an element that has already loaded.
 * Now there will be a slight flash when the image has not yet loaded, but that's an acceptable trade off.
 */
var ProgressiveImage = function ProgressiveImage(props) {
    var source = props.source,
        thumbnail = props.thumbnail,
        aspectRatio = props.aspectRatio,
        style = props.style,
        alt = props.alt,
        forcedWidth = props.forcedWidth,
        forcedHeight = props.forcedHeight,
        transparent = props.transparent;


    var styles = _extends({}, style, {
        paddingBottom: Math.floor(aspectRatio * 100) + '%'
    });

    return _react2.default.createElement(
        _ProgressiveImageFACC2.default,
        props,
        function (_ref) {
            var hideImage = _ref.hideImage;
            return _react2.default.createElement(
                _BackgroundImage2.default,
                { className: 'ProgressiveImage', style: styles, source: !transparent ? thumbnail : null },
                _react2.default.createElement('img', { className: (0, _classnames2.default)('image', { transparent: hideImage }),
                    src: source, alt: alt, width: forcedWidth, height: forcedHeight })
            );
        }
    );
};

ProgressiveImage.propTypes = {
    thumbnail: _propTypes2.default.string,
    source: _propTypes2.default.string.isRequired,
    aspectRatio: _propTypes2.default.number.isRequired,
    onImageLoad: _propTypes2.default.func,
    hasLoaded: _propTypes2.default.bool,
    style: _propTypes2.default.object,
    alt: _propTypes2.default.string,
    forcedWidth: _propTypes2.default.number,
    forcedHeight: _propTypes2.default.number,
    transparent: _propTypes2.default.bool,
    hideImage: _propTypes2.default.bool
};

exports.default = ProgressiveImage;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/images/progressiveImages/ProgressiveImage.js
// module id = 1903
// module chunks = 0